import { setupWorker } from "msw";

const makeHandlerRequireFn = () => require.context("./", true, /\.handler\.js$/);

const handlerFn = makeHandlerRequireFn();

// Load all `handler.js` files default exports into single array
// handler array must be either default or named export as `handlers`
const dynamicHandlers = [
    ...handlerFn.keys()
        .map(key => handlerFn(key))
        .flatMap(modExports => modExports.handlers || modExports.default)
];

// This configures a Service Worker with the given request handlers.
export const worker = setupWorker(...dynamicHandlers);
